/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { AuthenticationService } from '../../common/authentication/service/AuthenticationService';
import { PjInjectProxy } from '../../common/extends_fw/PjInjectProxy';
import { PjBaseController, Alert } from '../../common/extends_fw/controller/PjBaseController';
import { PjServiceResponse } from '../../common/extends_fw/service/PjServiceResponse';
import { MsgLevel } from '../../framework/controller/MsgLevel';
import { VideoService } from '../service/VideoService';
import { VideoCriteriaJson } from '../json/JsonAll';
import { VideoJson } from '../json/JsonAll';
import { VideoListJson } from '../json/JsonAll';
import { SelectItemJson } from '../json/JsonAll';
import { DeleteJson } from '../json/JsonAll';
import { SharedService } from '../../common/extends_fw/controller/PjBaseController';

/**
 * 動画画面について出力処理およびイベント処理を行う。
 */
export class VideoController extends PjBaseController {

    // 動画名
    public title: string;

    // カテゴリID
    public categoryId: string;

    // 動画説明
    public description: string;

    // 配信開始日
    public distributionDate: string;

    // グリッド情報
    public gridOptions: any;

    // 前回検索情報
    public criteria: VideoCriteriaJson;

    /**
     * コンストラクタ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $window: ng.IWindowService,
            protected $uibModal: ng.ui.bootstrap.IModalService,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected videoService: VideoService,
            protected $location: ng.ILocationService,
            protected sharedService: SharedService,
            protected $scope: any) {
        super($stateParams, $translate, $location, pjInjectProxy);

        if (!this.checkAuthenticatedUser()) {
            return;
        }

        this.setTitle('form15.title');
        this.gridOptions = {
            columnDefs: [
                {
                    field: 'title',
                    displayName: 'item.0065',
                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.title}}</a>' + '<div>',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'mainCategory',
                    displayName: 'item.0083',
                    width: '20%',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'subCategory',
                    displayName: 'item.0105',
                    width: '20%',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'distributionDate',
                    displayName: 'item.0071',
                    width: '13%',
                    headerCellFilter: 'translate'
                }
            ],
            enableRowSelection: true,
            enableSelectAll: true,
            enableColumnMenus: false,
            enableHorizontalScrollbar: 0,
            enableColumnResizing: true,
            paginationPageSizes: [10, 25, 100],
            paginationPageSize: 10,
            onRegisterApi: (gridApi: any) : void => {
                this.$scope.gridApi = gridApi;
            },
        };
        this.draw();
        this.$scope.show = (id: string) => {
            return this.show_dialog(id);
        };

        //  メインカテゴリリスト取得
        this.videoService.getMainCategoryList().then((mainData: any) => {
            $scope.mainCategoryList = {};
            $scope.mainCategoryList = mainData.data.categories;
        }).catch((errorData: any) => {
            this.catch(errorData);
        });

        //  sharedService
        let auth: any;

        auth = sharedService.get('auth');
        //  権限が無いユーザはTOPへ戻す
        if (!(auth.role === 2 || auth.role === 3 || auth.role === 4)) {
            this.$location.url('/top');
        }
        //  項目の表示制御(トーマツ)
        $scope.tohmatsu = this.isTohmatsu();
        //  読み取り専用か判定
        $scope.readUser = this.isReadonly();
        $scope.readUserBtn = !this.isReadonly();
        if (auth.role === 2) {
          //  項目の表示制御(会社)
          $scope.readUser = !this.isTohmatsu();
          $scope.readUserBtn = this.isTohmatsu();
        }
    }

    /**
     * ダイアログ表示
     */
    public show_dialog(id: string = null): void {
        let test: any = this.$uibModal.open({
            templateUrl: 'template/video/edit.html',
            controller: 'videoEditController',
            controllerAs: 'videoEdit',
            resolve: {
                id: function (): string {
                    return id;
                }
            },
        }).result.then((result: string) => {
            if (result) {
                this.clearAlert();
                if (result === 'delete') {
                    this.setAlert('message.0027');
                }
                this.reflesh_list(result);
            }
        });
    }

    public reflesh_list(result: string): void {
        this.videoService.list(this.criteria).then((data: any) => {
            this.$scope.gridApi.selection.clearSelectedRows();
            this.gridOptions.data.splice(0, this.gridOptions.data.length);
            Array.prototype.push.apply(this.gridOptions.data, data.data.videos);
            if (result !== 'delete') {
                this.clearAlert();
                if (data.status === 204) {
                    this.setAlert('message.0004');
                }
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    /**
     * 検索処理
     */
    public search(): void {
        let criteria: any = {
            title: this.title,
            categoryId: this.$scope.mainSelectedItem || null,
            description: this.description,
            distributionDate: this.distributionDate
        };
        this.criteria = criteria;
        this.reflesh_list('search');
    }

    public delete(): void {
        let rows: VideoJson[] = this.$scope.gridApi.selection.getSelectedRows();
        if (rows.length === 0) {
            alert(this.$translate.instant('MC0000001'));
            return;
        }
        if (!window.confirm(this.$translate.instant('CC0000001'))) {
            return;
        }
        this.videoService.delete(rows.map((x: VideoJson) => {return x.id; })).then((data: DeleteJson) => {
            this.clearAlert();
            this.setAlert('message.0027');
            this.reflesh_list('delete');
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(data: any): void {}

    /**
     * 表示処理
     */
    public show(): void {}
}

export class VideoEditController extends PjBaseController {

    // モーダル画面タイトル
    public modalTitle: string;

    // 更新ボタン見出し
    public submitCaption: string;

    // 画面情報
    public record: VideoJson;

    // サブカテゴリセレクトボックス数管理配列
    public subSelectedItem: any = [];

    public video: any;

    public thumbnail: any;

    // 履歴検索用
    public logName: any;

    public videoUrl: string;

    /**
     * コンストラクタ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected videoService: VideoService,
            protected $scope: any,
            protected $location: ng.ILocationService,
            protected sharedService: SharedService,
            protected $timeout: any,
            protected id: number = null) {
        super($stateParams, $translate, $location, pjInjectProxy);

        if (id) {
            this.modalTitle = 'form17.title';
            this.submitCaption = 'RC0000004';
            this.videoService.getRecord(id).then((data: any) => {
                data.data.video.thumbnailUrl = data.data.video.thumbnailUrl + '?m=' + new Date().getTime();
                this.record = data.data.video;

                this.logName = this.record.title;
                //  メインカテゴリリスト取得
                this.videoService.getMainCategoryList().then((editMainData: any) => {
                    $scope.mainCategoryList = editMainData.data.categories;
                    $scope.mainSelectedItem = this.record.mainCategoryId;
                }).catch((errorData: any) => {
                    this.catch(errorData);
                });

                //  サブカテゴリリスト取得
                this.videoService.getSubCategoryList(this.record.mainCategoryId).then((editSubData: any) => {
                    $scope.subCategoryList = editSubData.data.categories;
                }).catch((errorData: any) => {
                    this.catch(errorData);
                });

                if (this.record.subCategoryId !== 'null') {
                    //  this.record.subCategoryIdの要素数を区切り、数をカウント
                    let str: string = this.record.subCategoryId;
                    let ary: string[] = str.split(',');

                    //  各セレクトボックスにバルクの中身を設定
                    for (let j: number = 0; j < ary.length; j++) {
                        this.subSelectedItem.push(ary[j]);
                    }
                }

                this.record.distributionDate = new Date(this.record.distributionDate);

                this.videoService.url(this.record.videoUrl).then((url: any) => {
                    this.videoUrl = url.data.video.videoUrl; // + '?m=' + new Date().getTime();
                }).catch((errorData: any) => {
                    this.catch(errorData);
                });

//                let desc = this.record.description;
//                this.record.description = '動画説明';
//
//                this.$timeout(function(arg) {
//                    let record = arg;
//                    return function() {
//                        record.description = desc;
//                    };
//                }(this.record), 500);

            }).catch((errorData: any) => {
                this.catch(errorData);
            });
        } else {
            this.record = {};
            this.modalTitle = 'form16.title';
            this.submitCaption = 'RC0000002';
            //  メインカテゴリリスト
            this.videoService.getMainCategoryList().then((newMainData: any) => {
                $scope.mainCategoryList = newMainData.data.categories;
            }).catch((errorData: any) => {
                this.catch(errorData);
            });
        }
        let auth: any;

        auth = sharedService.get('auth');
        //  項目の表示制御(トーマツ)
        $scope.tohmatsu = this.isTohmatsu();
        //  読み取り専用か判定
        $scope.readUser = this.isReadonly();
        $scope.readUserBtn = !this.isReadonly();
        $scope.comManager = true;
        if (auth.role === 2) {
            //  項目の表示制御(会社)
            $scope.readUser = !this.isTohmatsu();
            $scope.readUserBtn = this.isTohmatsu();
            $scope.comManager = false;
        }
    }

    public changeItem: any = function(): any {
        let delCnt: number = this.subSelectedItem.length;
        for (let i: number = 0; i < delCnt; i++) {
            this.subSelectedItem.pop();
        }
        this.$scope.subCategoryList = [];
        if (!this.$scope.mainSelectedItem) {
            return;
        }
        this.videoService.getSubCategoryList(this.$scope.mainSelectedItem).then((newSubData: any) => {
            this.$scope.subCategoryList = newSubData.data.categories;
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    };

    public delete(): void {
        if (!window.confirm(this.$translate.instant('CC0000001'))) {
            return;
        }
        this.videoService.delete([this.id]).then((data: DeleteJson) => {
            this.$uibModalInstance.close('delete');
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    public update(): void {
        this.record.subCategoryId = this.subSelectedItem.filter(function (x: any, i: any, self: any): boolean {
            return self.indexOf(x) === i && x !== '';
        }).join(',');
        this.record.mainCategoryId = this.$scope.mainSelectedItem;
        console.log(this.record);
        if (this.id === null) {
            this.videoService.create(this.record, this.video, this.thumbnail).then((data: VideoJson) => {
                this.$uibModalInstance.close('create');
            }).catch((errorData: any) => {
                this.catch(errorData);
            });
        } else {
            this.videoService.update(this.record, this.video, this.thumbnail).then((data: VideoJson) => {
                this.$uibModalInstance.close('update');
            }).catch((errorData: any) => {
                this.catch(errorData);
            });
        }
    }

    // 追加削除button
    public add(): any {
        this.subSelectedItem.push('');
    }

    public del(indexNum: number): any {
        this.subSelectedItem.splice(indexNum, 1);
    }

    public log(): void {
        this.$uibModalInstance.close('log');
        this.$location.url('/history/video/' + this.logName.replace(/\//g,'_slash-'));
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(data: any): void {}

    /**
     * 表示処理
     */
    public show(): void {}
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/controller/VideoController.ts
 **/